<template>
  <v-dialog :key="changeKey" v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <v-card-text>
        <div class="text-center py-10">
          <v-img
            @click="closeDialog"
            class="cancel-image"
            src="../assets/icons/cancel.png"
            height="15px"
            width="15px"
          />
          <h3>{{ dialogTitle }}</h3>
          <p class="my-3">{{ "lng_box_detail_txt" | translate }}</p>
        </div>
        <v-form class="ma-2 mt-3" ref="updateBox" lazy-validation>
          <div class="fields-group my-5">
            <span class="group-title">{{ "lng_alarm_options" | translate }}</span>
            <v-text-field 
              :label="'lng_email_alarm_label' | translate"
              v-model="alarmEmail"></v-text-field>
            <!-- <v-text-field 
              :label="'lng_phone_alarm_label' | translate"
              v-model="alarmPhone"></v-text-field> -->
            <VuePhoneNumberInput class="mb-2"
              default-country-code="DK"
              :translations="translations"
              v-model="alarmPhone"
              @update="onUpdatePhone" />
            <v-text-field
              :label="'lng_alarm_prefix_label' | translate"
              v-model="alarmPrefix" counter="10" maxlength="10"></v-text-field>  
          </div>
          <div class="fields-group my-5">
            <span class="group-title">{{ "lng_misc_txt" | translate }}</span>
            <v-text-field 
              :label="'lng_th_mac_number_txt' | translate"
              v-model="macNumber"></v-text-field>
              <v-select
                :label="'lng_sewer_type_txt' | translate"
                class="mt-0 pt-0"
                :items="sewerTypes"
                :value="selectedSewerType"
                item-text="name"
                item-value="value"
                menu-props="auto"
                return-object
                @change="value => {selectedSewerType = value}"
              >
                <template v-slot:selection="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
                <template v-slot:item="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
              </v-select>
              <v-select
                :label="'lng_equipment_type_txt' | translate"
                class="mt-0 pt-0"
                :items="equipmentTypes"
                :value="selectedEquipmentType"
                item-text="name"
                item-value="value"
                menu-props="auto"
                return-object
                @change="value => {selectedEquipmentType = value}"
              >
                <template v-slot:selection="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
                <template v-slot:item="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
              </v-select>
          </div>
          <div class="fields-group my-5">
            <span class="group-title">{{ "lng_th_address" | translate }}</span>
            <v-text-field 
              :label="'lng_address1_text' | translate"
              v-model="address1" :rules="[rules.required]"></v-text-field>
            <v-text-field 
              :label="'lng_address2_text' | translate"
              v-model="address2"></v-text-field>
            <v-row>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :label="'lng_city_text' | translate"
                v-model="city"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :label="'lng_zip_text' | translate"
                v-model="zip"
                :rules="[rules.required]"
              ></v-text-field>
            </v-row>
            <v-select
              class="mt-0 pt-0"
              :items="countryItems"
              :value="selectedCountry.value"
              item-text="name"
              item-value="value"
              menu-props="auto"
              return-object
              @change="
                      value => {
                        selectedCountry = value;
                      }
                    "
            ></v-select>
          </div>
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn color="#0B7894" dark @click="validate" :loading="showLoading">{{ "lng_save_txt" | translate }}</v-btn>
          </div>
        </v-form>
      </v-card-text>
      <Alert
        v-if="alertToggle"
        :message-data="flashMessageData"
        :alert-toggle="alertToggle"
        @alertToggleUpdate="alertToggle = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { countries, sewerTypeValues, equipmentTypeValues } from "../common/Constant";
import { getCountryByPhone } from "../common/HelperFunctions.js";
import UserService from "../services/user-service";
import router from "../router";
import { translateFunc } from '../common/Filters';
import Alert from "../components/Alert";
import VuePhoneNumberInput from 'vue-phone-number-input';


export default {
  name: "updateBoxAddress",
  components: {
    Alert,
    VuePhoneNumberInput
  },
  data() {
    return {
      dialog: false,
      systemId: "",
      showPass: false,
      address1: "",
      address2: "",
      city: "",
      zip: "",
      countryItems: countries,
      selectedCountry: {
        name: "Denmark",
        value: "DK"
      },
      rules: {
        required: value => !!value || translateFunc("lng_required_text"),
        counter: value => value.length <= 20 || translateFunc("lng_required_length"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || translateFunc("lng_required_validate_email");
        }
      },
      showLoading: false,
      error: "",
      alarmEmail: "",
      alarmPhone: "",
      alarmPrefix: "",
      alertToggle: false,
      flashMessageData: {},
      phoneObject: {},
      translations: {
        countrySelectorLabel: translateFunc('lng_country_code_txt'),
        countrySelectorError: translateFunc('lng_country_code_error_txt'),
        phoneNumberLabel: translateFunc("lng_phone_alarm_label"),
        example: translateFunc('lng_example_text'),
      },
      macNumber: null,
      sewerTypes: sewerTypeValues,
      selectedSewerType: {
        name: "lng_other_txt",
        value: "other"
      },
      equipmentTypes: equipmentTypeValues,
      selectedEquipmentType: {
        name: "lng_select_eq_type_txt",
        value: "other"
      },
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    completeAddress: {
      type: Object,
      default: () => {}
    },
    userToken: {
      type: String,
      default: ""
    },
    changeKey: {
      type: Number,
      default: 0
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    completeAddress: function(newVal) {
      console.log("========watch : ", newVal);
      this.systemId = newVal.id;
      this.address1 = newVal.addr1;
      this.address2 = newVal.addr2;
      this.city = newVal.city;
      this.zip = newVal.zip;
      this.alarmEmail = newVal.alarmemail;
      // this.alarmPhone = newVal.alarmsms;
      this.alarmPhone = getCountryByPhone(newVal.alarmsms);
      this.alarmPrefix = newVal.alarmprefix;
      this.macNumber = newVal.mecnumber
      let index = countries.findIndex(e => e.name === newVal.country);
      if (index !== -1) {
        this.selectedCountry = countries[index];
      }
      let sewerTypeIndex = sewerTypeValues.findIndex(e => e.value === newVal.sewertype);
      if (sewerTypeIndex !== -1) {
        this.selectedSewerType = sewerTypeValues[sewerTypeIndex];
      }
      let eqTypeIndex = equipmentTypeValues.findIndex(e => e.value === newVal.uwsequipment);
      if (eqTypeIndex !== -1) {
        this.selectedEquipmentType = equipmentTypeValues[eqTypeIndex];
      } else {
        this.selectedEquipmentType = { name: "lng_select_eq_type_txt", value: "other"}
      }
    }
  },
  mounted() {},
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.updateBox.validate()) {
          await this.getLatLng();
        }
      });
    },
    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        await this.saveBox(location.results[0].geometry.location);
      } else {
        console.log("location not found");
        this.error = translateFunc("lng_missing_city_txt")
        this.showAlert({msg: translateFunc("lng_missing_city_txt"), status: 1});
      }
    },
    async saveBox(location) {
      this.error = "";
      this.showLoading = true;
      let response;
      
      // if(!this.phoneObject.formattedNumber || (this.phoneObject.formattedNumber && this.phoneObject.isValid) ){
        let phoneNumber = this.phoneObject.formattedNumber ? this.phoneObject.formattedNumber.replace("+", "") : "";
        try {
          let paramString = `systemid=${this.completeAddress.id}&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(this.address2)}&city=${this.city}&zip=${this.zip}&country=${this.selectedCountry.name}&lat=${location.lat}&lng=${location.lng}&alarmemail=${this.alarmEmail}&alarmsms=${phoneNumber}&alarmprefix=${this.alarmPrefix}&mecnumber=${this.macNumber}&sewertype=${this.selectedSewerType.value}&uwsequipment=${this.selectedEquipmentType.value}`;
          response = await UserService.changeBoxSettings(
            this.userToken,
            paramString
          );
        } catch (e) {
          this.error = translateFunc("lng_try_again_txt");
          this.showLoading = false;
          this.showAlert({msg: translateFunc("lng_try_again_txt"), status: 1});
        }
        if (!response.status) {
          this.error = "";
          this.showLoading = false;
          this.$emit("updateLocalData");
          this.showAlert(response);
          setTimeout(() => {
            this.closeDialog();
          }, 1000);
        } else {
          this.showLoading = false;
          this.error = response.msg;
          this.showAlert(response);
        }
      // } else {
      //   this.error = "phone number is invalid";
      //   this.showLoading = false;
      // }
    },
    showAlert(res){
      this.flashMessageData = res;
      this.alertToggle = true;
    },
    onUpdatePhone (payload) {
      this.phoneObject = payload
    },
  }
};
</script>
<style scoped>
/* .close-btn {
  color: rgba(0, 0, 0, 0.87);
} */
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 90%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
</style>
